import { Mandarin } from 'flatpickr/dist/l10n/zh'
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw'
import { Japanese } from 'flatpickr/dist/l10n/ja'
import { Korean } from 'flatpickr/dist/l10n/ko'
import { Hindi } from 'flatpickr/dist/l10n/hi'
import { Spanish } from 'flatpickr/dist/l10n/es'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { French } from 'flatpickr/dist/l10n/fr'
import { German } from 'flatpickr/dist/l10n/de'
import { Italian } from 'flatpickr/dist/l10n/it'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import { Turkish } from 'flatpickr/dist/l10n/tr'
import { Dutch } from 'flatpickr/dist/l10n/nl'

export default {
  en: 'default',
  'zh-CN': Mandarin,
  'zh-TW': MandarinTraditional,
  ja: Japanese,
  ko: Korean,
  hi: Hindi,
  'es-ES': {
    ...Spanish,
    scrollTitle: 'Desplázate para aumentar',
    toggleTitle: 'Haz clic para alternar',
    yearAriaLabel: 'Año',
    monthAriaLabel: 'Mes',
    hourAriaLabel: 'Hora',
    minuteAriaLabel: 'Minuto',
  },
  'pt-PT': {
    ...Portuguese,
    firstDayOfWeek: 1,
    scrollTitle: 'Desloque para aumentar',
    toggleTitle: 'Clique para alternar',
    yearAriaLabel: 'Ano',
    monthAriaLabel: 'Mês',
    hourAriaLabel: 'Hora',
    minuteAriaLabel: 'Minuto',
  },
  fr: French,
  de: German,
  it: Italian,
  id: Indonesian,
  tr: Turkish,
  nl: Dutch,
}
